import axios from "axios";

import { API_HOST, API_PATH } from "@type/config";
import { ENDPOINT } from "@type/api/endpoint";

export const getRefreshToken = async (
  refreshToken: string,
  existingToken: string
) => {
  try {
    const { method, url } = ENDPOINT.USER.GET_REFRESH_TOKEN;

    const response = await axios({
      method,
      baseURL: `${API_HOST}${ENDPOINT.USER.GET_REFRESH_TOKEN.version}${API_PATH}`,
      url,
      headers: {
        "Content-Type": "application/json",
        Authorization: existingToken,
      },
      data: {
        refresh_token: refreshToken,
      },
    });

    // Check if the response contains the tokens
    const { refresh_token: newRefreshToken, access_token: accessToken } =
      response.data || {};

    if (!accessToken || !newRefreshToken) {
      throw new Error("Refresh token request was not successful.");
    }

    return {
      refreshToken: newRefreshToken,
      accessToken,
    };
  } catch (err) {
    throw new Error("Unable to get refresh token.");
  }
};
